module.exports = __webpack_public_path__ + "static/2front-about-company-1-ee30590fc61f483f712c5225d929b9ee.png";